import { cn } from '@1trading/react';

const JSON_INDENT = 2;

interface JsonBlockProps {
  value: unknown;
  /** Size/background overrides, e.g. 'max-h-40' — merged over the defaults */
  className?: string;
}

/** Pretty-printed JSON inside its own scrollable container — the parent never overflows the page. */
export const JsonBlock = ({ value, className }: JsonBlockProps) => (
  <pre className={cn('max-h-72 overflow-auto rounded-md border bg-muted/40 p-3 text-xs', className)}>{JSON.stringify(value, null, JSON_INDENT)}</pre>
);
JsonBlock.displayName = 'JsonBlock';
